const $ = require("jquery");
window.jQuery = $;
window.$ = $;

const boostrap = require("bootstrap");
window.bootstrap = boostrap;

//const viewport = require("../../3rdParty/responsiveBootstrapToolkit");
//window.viewport = viewport;

const lity = require("../../3rdParty/lity.min");
window.lity = lity;

import { site } from "./site";
//import { teaserListWidget } from "./teaserListWidget";
//import { featuredItemsCarouselWidget } from "./featuredItemsCarouselWidget";
import { fixedHeader } from "./fixedHeader";
//import { tabsWidget } from "./tabsWidget";
import { lazyLoadImages } from './lazyLoad';
import { rememberUtm } from './remember.utm';
//import { share } from './share';

export function siteInit() {    
    site();
    fixedHeader();
    rememberUtm();
    lazyLoadImages();    
    //share();
    //teaserListWidget(); SU: looks like it is not used anymore
    //featuredItemsCarouselWidget(); SU: looks like it is not used anymore
    //tabsWidget(); SU: looks like it is not used anymore
}